import { create } from "zustand";
import { produce } from "immer";

const defaultData = {
  isLoading: false,
  isWaiting: false,
  packagesReport: [],
  summary: { packagesSold: 0, bathOpens: 0, servicesOpens: 0, revenue: 0 },
  filter: { dateFrom: null, dateTo: null, status: "*", cpf: "", search: "" },
  sort: { sortBy: "lastPackage", sortOrder: "desc" },
  pagination: { page: 0, totalPages: 0, perPage: 50, totalDocuments: 0 },
};

export const usePackagesReport = create((set) => ({
  data: defaultData,
  actions: {
    setPackagesReport: (packages, pagination) =>
      set((state) =>
        produce(state, (draft) => {
          const page = typeof pagination === "number" ? pagination : pagination.page;
          draft.data.packagesReport[page] = packages;
          draft.data.pagination = pagination;
          draft.data.isLoading = false;
          draft.data.isWaiting = false;
        })
      ),
    setSummary: (summary) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.summary = { ...state.data.summary, ...summary };
        })
      ),
    setFilter: (filterProps) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.filter = { ...state.data.filter, ...filterProps };
        })
      ),
    setSort: (sortProps) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.sort = { ...state.data.sort, ...sortProps };
        })
      ),
    setPaginationPage: (page) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.pagination.page = page;
        })
      ),
    setLoading: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.isLoading = status;
          draft.data.isWaiting = status;
        })
      ),
    setWaiting: (status) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.isWaiting = status;
        })
      ),
    clearPackagesReport: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.packagesReport = [];
        })
      ),
    clear: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = defaultData;
        })
      ),
  },
}));
